<i class="fa {{iconClass()}} color-{{color}}" aria-hidden="true"></i>
